// extracted by css-extract-rspack-plugin
export default {"loadingContainer":"HtmlPreview-module__loadingContainer__zyXla","loadingHead":"HtmlPreview-module__loadingHead__tctD4","loadingText":"HtmlPreview-module__loadingText__ZWULJ"};